export const M_SET_SEARCHED = "M_SET_SEARCHED";
export const M_SET_DATE = "M_SET_DATE";
export const M_SET_DIRECT = "M_SET_DIRECT";
export const M_SET_API_URL = "M_SET_API_URL";
export const M_SET_API_ORIGIN = "M_SET_API_ORIGIN";
export const M_SET_AVIA_QUOTA = "M_SET_AVIA_QUOTA_FOR_TICKETS"
